/**
 * @module interface
 */
export interface V2TimSoundElem {
    path?: string;
    UUID?: string;
    dataSize?: number;
    duration?: number;
    url?: string;
    localUrl?: string;
}
